<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>MODULES</div>
				<h2 waHeading="l" waText>JPMS Module Graph</h2>
				<p waBody="m" waColorText="quiet" waText>Explicit requires, explicit exports &mdash; no surprises.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<markdown [data]="mdContent_24"></markdown>
				<div class="mermaid-diagram-wrapper">
					<div class="mermaid-diagram-label" waCaption="s" waFontWeight="semibold" waText>Core Module Dependencies</div>
					<div class="mermaid-diagram">
						<markdown [data]="mdContent_25" mermaid></markdown>
					</div>
				</div>
				<div class="wa-cluster wa-gap-s">
					<wa-button [routerLink]="['/plugins']" variant="brand">Browse All Plugins</wa-button>
					<wa-button [routerLink]="['/capabilities']" appearance="outlined" variant="neutral">View Capabilities</wa-button>
				</div>
			</div>
		</div>
	</div>
</div>